export const PENDING_TASKS = 'pendingTasks';
export const ERROR_TASKS = 'errorTasks';
export const ASSETS = 'assets';
export const ATTACHMENTS = 'attachments';
export const CARD_ATTACHMENT_TYPE = 'cardAttachment';
export const CARD_PICTURE_ASSET_TYPE = 'cardPicture';
